<template>
   <ElConfigProvider :locale="locale">
    <myheader></myheader>
  </ElConfigProvider>
</template>

<script>
import myheader from "./components/rootpanel.vue";
//import { useStorage } from "vue3-storage";
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import en from 'element-plus/lib/locale/lang/en'
import {reactive,toRefs,watch,getCurrentInstance} from 'vue'
// import { useI18n } from "vue-i18n"; //要在js中使用国际化
export default {
  name: "App",
  components: {
    myheader,
    ElConfigProvider
  },
  setup() {
    // const storage = useStorage();
    // storage.setStorageSync("test-key", "testdata22");
    const { proxy } = getCurrentInstance();
    
    const state = reactive({
      locale: en,
    });

    watch(
      () => proxy.$i18n.locale,
      () => {
        if(proxy.$i18n.locale==='zh')
           state.locale=zhCn
        else if(proxy.$i18n.locale==='en')
           state.locale=en
      }
    );
    return{...toRefs(state)}
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width:100vw;
	height:100vh;
	display:flex;
	flex-flow:column nowrap;
	/* overflow:hidden; */

  /* margin-top: 60px; */
}

</style>
